import '@fortawesome/fontawesome-free/css/all.min.css';
import { useEffect, useState } from 'react';

const columnOrder = [
    "itemCode", "itemName", "warrantyYear", "warrantyMonth", "qty", "sellPrice",
    "discAmt", "vATYesNo", "unitTotal", "stock"
];


export default function ItemTable({ items, pCode, setItems }) {
    const [editCell, setEditCell] = useState({ rowIndex: null, columnKey: null });
    const [updatedItems, setUpdatedItems] = useState([]);

    const nonEditableFields = ['itemCode', 'itemName'];

    useEffect(() => {
        setUpdatedItems(items);
    }, [items]);

    useEffect(() => {
        if (updatedItems && updatedItems.length > 0)
            setItems(updatedItems);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatedItems])

    const handleCellClick = (rowIndex, columnKey) => {
        if (!nonEditableFields.includes(columnKey)) {
            setEditCell({ rowIndex, columnKey });
        }
    };

    const handleInputChange = (rowIndex, columnKey, value) => {
        const updatedData = [...updatedItems];
        updatedData[rowIndex][columnKey] = value;
        setUpdatedItems(updatedData);
    };

    const handleRemoveItem = (rowIndex) => {
        const updatedData = updatedItems.filter((_, index) => index !== rowIndex);
        if (updatedData.length === 0) {
            setItems([]);
        }

        setUpdatedItems(updatedData);
    };

    return (
        <div className="table-container table__height--1">
            <table className="table">
                <thead className="thead--color">
                    <tr>
                        <th>Item</th>
                        <th>Description</th>
                        <th>W.Y</th>
                        <th>W.M</th>
                        <th>Qty</th>
                        <th>Sell Price</th>
                        <th>Disc Amt</th>
                        <th>VAT</th>
                        <th>Unit Total Without VAT</th>
                        <th>Stock</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {updatedItems.map((item, rowIndex) => (
                        <tr key={rowIndex}>
                            {columnOrder.map((columnKey) => (
                                <td
                                    key={columnKey}
                                    onClick={() => handleCellClick(rowIndex, columnKey)}
                                    style={{
                                        color: nonEditableFields.includes(columnKey) ? '#a0a0a0' : 'inherit', // Gray out text
                                        backgroundColor: nonEditableFields.includes(columnKey) ? '#f5f5f5' : 'transparent', // Add subtle background
                                        cursor: nonEditableFields.includes(columnKey) ? 'not-allowed' : 'pointer', // Change cursor
                                    }}
                                >
                                    {editCell.rowIndex === rowIndex &&
                                        editCell.columnKey === columnKey &&
                                        !nonEditableFields.includes(columnKey) ? (
                                        <input
                                            type="text"
                                            value={item[columnKey]}
                                            onChange={(e) =>
                                                handleInputChange(rowIndex, columnKey, e.target.value)
                                            }
                                            onBlur={() => setEditCell({ rowIndex: null, columnKey: null })}
                                            autoFocus
                                        />
                                    ) : (
                                        item[columnKey]
                                    )}
                                </td>
                            ))}
                            <td>
                                <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleRemoveItem(rowIndex)}
                                >
                                    <i className="fa fa-minus-circle" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
